import type {
  MerchandiserView,
  SectionItemDM,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { layoutMerchandiser } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/LayoutMerchandiser';
import { calculateMerchandiserInternals } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/MerchandiserLayout';

export async function addMerchandiser(
  viewData: ViewData,
  section: SectionItemDM
): Promise<ViewData> {
  const merchandiserView = getMerchandiserView(viewData, section);

  const placeholderCard = layoutMerchandiser({
    section: merchandiserView,
    layoutTable: viewData.layoutTable!,
  });
  // add `internals` prop to merchandiser GridCard.data
  calculateMerchandiserInternals(placeholderCard);

  return viewData;
}

function getMerchandiserView(
  viewData: ViewData,
  section: SectionItemDM
): MerchandiserView {
  return {
    id: section.id,
    key: [
      'brandconcession',
      viewData.modelData.concessionId,
      'section',
      section.id,
    ].join('-'),
    type: section.template,
    dtoData: section,
    sectionId: section.id,
  };
}
